const SUPPORT_NUMBER = '966574271703';
const DEFAULT_MESSAGE = 'Hi! I need support with Abaya DIY.';

const whatsappUrl = `https://wa.me/${SUPPORT_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

export default function WhatsAppStickyButton() {
  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with support on WhatsApp"
      title="WhatsApp Support"
      className="fixed left-3 bottom-24 z-40 inline-flex h-11 w-11 items-center justify-center rounded-full bg-[#a57a6a] text-white shadow-lg transition-all duration-200 hover:scale-105 hover:bg-[#8a6a5a] active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#a57a6a] focus-visible:ring-offset-2 sm:bottom-6 sm:left-4 sm:h-14 sm:w-14"
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        className="h-8 w-8 sm:h-9 sm:w-9"
        fill="currentColor"
      >
        <path d="M19.05 4.94A9.9 9.9 0 0 0 12.02 2C6.53 2 2.06 6.47 2.06 11.96c0 1.75.46 3.46 1.32 4.97L2 22l5.2-1.36a9.9 9.9 0 0 0 4.81 1.23h.01c5.49 0 9.96-4.47 9.96-9.96 0-2.66-1.03-5.15-2.93-6.97Zm-7.03 15.25h-.01a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.09.81.82-3.01-.2-.31a8.24 8.24 0 0 1-1.27-4.39c0-4.54 3.69-8.23 8.24-8.23 2.2 0 4.26.86 5.82 2.41a8.17 8.17 0 0 1 2.41 5.82c0 4.54-3.69 8.23-8.24 8.23Zm4.52-6.17c-.25-.12-1.47-.72-1.7-.8-.23-.08-.39-.12-.56.12-.16.25-.64.8-.78.97-.14.16-.29.19-.54.06-.25-.12-1.04-.38-1.97-1.21-.73-.65-1.22-1.45-1.36-1.69-.14-.25-.02-.38.1-.5.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.16.04-.31-.02-.43-.06-.12-.56-1.35-.77-1.85-.2-.48-.4-.41-.56-.42h-.48c-.16 0-.43.06-.66.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.02 2.56.12.16 1.75 2.67 4.23 3.75.59.25 1.06.4 1.42.51.6.19 1.14.16 1.57.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.14-1.18-.06-.11-.23-.17-.48-.29Z" />
      </svg>
    </a>
  );
}
